L.Edit ?= {}

class L.Edit.BetterPoly extends L.Edit.Poly

    initialize: (poly, options) ->
        super(poly, options)

        L.Edit.BetterPoly.include(L.Mixin.Events)

    _initMarkers: () ->
        if not @_markerGroup
            @_markerGroup = new L.LayerGroup()

        @_markers = []

        latlngs = @_getLatLngs()

        @_buildLineMarkers latlngs

        @_prevLength = @_markers.length

    # Retrieves latlngs we set. This allows holes to be editable because we can
    # pass the hole's array of latlngs and that will be referenced for any edits
    # instead of @_poly._latlngs
    _getLatLngs: () ->
        return @options.latlngs


    # Handles creating markers on the map and initializing their events.
    # this method doesn't exist in Edit.Poly, because @_initMarkers
    # was hardcoded to look at @_poly._latlngs. Now we check the options
    # to get latlngs and pass the array here
    _buildLineMarkers: (latlngs) ->
        for v, i in latlngs
            marker = @_createMarker v, i
            marker.on 'click', @_onMarkerClick, this
            @_markers.push marker

        for i in [0..(latlngs.length - 1)]
            #if i is 0 && not (L.Polygon and (@_poly instanceof L.Polygon))
            #    continue
            #


            markerRight  = @_markers[i]
            if i is 0
                markerLeft = @_markers[latlngs.length - 1]
            else
                markerLeft = @_markers[i - 1]

            @_createMiddleMarker markerLeft, markerRight
            @_updatePrevNext markerLeft, markerRight


    # Handles when a marker is deleted (default by double clicking on it)
    # Previously, this was splicing onto @_poly._latlngs, which breaks things
    # when you try removing a marker from a hole
    _removeMarker: (marker) ->
        if not @_destroyed
            @_poly?._map?.fire?('draw:point-begin-remove')

        i = marker?._index
        if marker?
            @_markerGroup?.removeLayer?(marker)
            @_markers?.splice(i, 1)
            @options?.latlngs.splice(i, 1)
            @_updateIndexes?(i, -1)

            @_poly?.redraw?()


        marker?.clearAllEventListeners?()

        #    .off('drag', @_onMarkerDrag, this)
        #    .off('dragend', @_fireEdit, this)
        #    .off('click', @_onMarkerClick, this)



    removeHooks: () ->
        @_destroyed = true
        @clearAllEventListeners()
        super()

    # Handles when a user drags a marker. We only override this so we can
    # fire an event when points are dragged
    _onMarkerDrag: (e) ->
        super(e)

        @_poly._map.fire 'draw:point-edited'


    _fireEdit: () ->
        @_poly.edited = true

        if @_prevLength < @_markers.length
            @_prevLength = @_markers.length
            @_poly._map.fire 'draw:point-removed'
        else
            @_poly._map.fire 'draw:point-finished-edit'
        @_poly.fire('edit')


    _createMarker: (latlng, index) ->

        marker = super(latlng, index)

        marker.on 'dragstart', () =>
            @_poly._map.fire('draw:point-begin-edit')

        marker.on 'dragend', () =>
            @_poly._map.fire('draw:point-drag-end')

        return marker



    # Handle when the user clicks on the "ghost" middle marker; The current Edit.Poly
    # directly splices onto @_poly._latlngs, which if course breaks everything if
    # you are trying to edit a hole
    _createMiddleMarker: (marker1, marker2) =>
        if not @_poly?._map?
            return

        latlng = @_getMiddleLatLng(marker1, marker2)
        marker = @_createMarker(latlng)

        marker.setOpacity(0.6)

        marker1._middleRight = marker2._middleLeft = marker

        onDragStart = () ->
            i = marker2._index

            marker._index = i

            marker#.off('click', onClick, @)
                .on('click', @_onMarkerClick, this)

            latlng.lat = marker.getLatLng().lat
            latlng.lng = marker.getLatLng().lng

            @options.latlngs.splice(i, 0, latlng)

            @_markers.splice(i, 0, marker)

            marker.setOpacity(1)

            @_updateIndexes(i, 1)
            marker2._index++
            @_updatePrevNext(marker1, marker)
            @_updatePrevNext(marker, marker2)


        onDragEnd = () ->
            marker.off('dragstart', onDragStart, this)
            marker.off('dragend', onDragEnd, this)
            try
                @_createMiddleMarker(marker1, marker)
                @_createMiddleMarker(marker, marker2)
            catch e
                # this happens when we try to add ghost markers to a shape that no longer exists

        #onClick = () ->
        #    onDragStart.call(this)
        #    onDragEnd.call(this)
        #    @_fireEdit()

        marker
            #.on('click', onClick, this)
            .on('dragstart', onDragStart, this)
            .on('dragend', onDragEnd, this)

        @_markerGroup.addLayer(marker)
